export const trackEvent = (eventName, properties) => {
  // Console logging for observability during development and staging
  console.log(`[Analytics V2] Event: ${eventName}`, properties);

  // Implement the actual tracker here (e.g., Google Analytics, Meta Pixel, PostHog)
  // Ensure no PII (Personally Identifiable Information) is sent.
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, properties);
  }
};

export const EVENTS = {
  LP_VIEW: 'lp_view',
  HERO_CTA_CLICK: 'hero_cta_click',
  SECTION_VIEW: 'section_view',
  DIAGNOSTIC_START: 'diagnostic_start',
  DIAGNOSTIC_STEP_COMPLETE: 'diagnostic_step_complete',
  DIAGNOSTIC_EXIT: 'diagnostic_exit',
  LEAD_FORM_VIEW: 'lead_form_view',
  LEAD_FORM_SUBMIT: 'lead_form_submit',
  LEAD_FORM_ERROR: 'lead_form_error',
  EXPERIMENT_EXPOSURE: 'experiment_exposure',
};
